import React, { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

const RedirectToLowercase: FC = ({ children }) => {
  const location = useLocation();
  const shouldRedirect = location.pathname !== location.pathname.toLowerCase();

  return shouldRedirect ? <Redirect to={location.pathname.toLowerCase()} /> : <>{children}</>;
};

export default RedirectToLowercase;
